import { ApiResponse, http } from '@config/api';

export interface Specialties {
	id: string;
	name: string;
}

export async function getAllSpecialties(): Promise<Specialties[]> {
	const response = await http.get<ApiResponse<Specialties[]>>('specialties', '');

	return response.data.data;
}
